import { render, staticRenderFns } from "./jcsystem.vue?vue&type=template&id=99df5e0c&scoped=true&"
import script from "./jcsystem.vue?vue&type=script&lang=js&"
export * from "./jcsystem.vue?vue&type=script&lang=js&"
import style0 from "./jcsystem.vue?vue&type=style&index=0&id=99df5e0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99df5e0c",
  null
  
)

export default component.exports